// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2btb_","container":"styles_container__sUEED","title":"styles_title__2g0MN","wrapper":"styles_wrapper__21ZKb","answer":"styles_answer__1cFxz"};